import {ErrorBase} from '../../error';

export class MissingApplicationConfigurationError extends ErrorBase {}
